import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("i", {
    style: _normalizeStyle([{"color":"red"}, { color: _ctx.color, fontSize: _ctx.size + 'px', fontWeight: _ctx.fontWeight }]),
    class: _normalizeClass('iconfont ' + _ctx.name)
  }, null, 6))
}